import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaseReferencePipe } from './case-reference/case-reference.pipe';
import { SortCaseTypesPipe } from './sort/sort-case-types.pipe';
import { SortSearchResultPipe } from './search-result/sorting/sort-search-result.pipe';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    CaseReferencePipe,
    SortCaseTypesPipe,
    SortSearchResultPipe,
  ],
  exports: [
    CaseReferencePipe,
    SortCaseTypesPipe,
    SortSearchResultPipe,
  ]
})
export class PipesModule {}
